import MDialog from './index.vue'

MDialog.install = function (Vue) {
    Vue.component(MDialog.name, MDialog)
}

export default MDialog